import React from 'react'
import Layout from './components/Layout'
import RecipeBoxCarousel from './components/RecipeBoxCarousel'
import About from './components/About'
import Categories from './components/Categories'
import { Provider } from './components/context/Context';

function Home() {

  return (
    
        <Layout>
            <Provider>
                <RecipeBoxCarousel />
                <About/>
                <Categories/>
            </Provider>
        </Layout>
    
  )
}

export default Home